<template>
    <div id="div-with-loading" class="upload-rebate-list-lander vs-con-loading__container">
        <div class="vx-row">
            <vx-card class="centered-page-container">
                <div class="vx-row flex-wrap heading-with-logo px-4">
                    <h2> Upload Rebate File </h2>

                    <!-- TODO: Add it back when the logos for all partners are added to system -->
                    <!-- <div><img src="../../assets/images/partner-logos/GoDaddy-Black.png" alt=""></div> -->
                </div>

                <hr>

                <div class="content-wrapper">
                    <p class="salutation"> Hi {{ pocName }},</p>

                    <p class="para">As per our records, below are the rebate list(s) due to be received from you. Please upload them in the box below in the pre-determined format. If you do not have the format handy, you can always download a sample list <a :href="sampleFile.url" @click.prevent="downloadSampleFile(sampleFile)">here</a>.</p>
                    
                    <p class="mt-5">We request you to please submit your list(s) by <strong>{{ dueDateForUpload }}</strong> in order for us to process the payment in this cycle.</p>

                    <p class="para"><strong>Rebate List For: {{ period }}</strong></p>

                    <p class="para"><strong>Upload Rebate List</strong></p>

                    <vs-button id="button-with-loading" color="primary" type="filled" class="custom-btn-upload ml-auto mt-3" @click="uploadRebateLists()" icon-after>Click To Upload</vs-button>

                    <p class="download-note mt-3"> <feather-icon icon="FileIcon" color="primary" class="primary"/> <u><a :href="sampleFile.url" @click.prevent="downloadSampleFile(sampleFile)">Click Here To Download Sample Rebate List Format</a></u></p> <br>
                    
                    <p class="para">Please Note: Only submit data for the period of {{ dataDateRangeStart }} to {{ dataDateRangeEnd }}. Any data lying out of this date range will be automatically rejected. To submit data for periods in the past, please click the ‘+’ button to add a second list.</p>
                </div>
            </vx-card>
        </div>

        <UploadRebateLists></UploadRebateLists>
    </div>
</template>

<script>
import UploadRebateLists from "@/components/partner/UploadRebateLists.vue";

export default {
    name: "UploadRebateListLander",
    components: {
        UploadRebateLists,
    },
    data() {
        return this.initData();
    },
    mounted() {
        this.$root.$on('submitRebateList', async (status) => {            
            this.$root.$emit('switchComponentInCurrentCycle',status);
        })
    },
    beforeMount() {
        // NOTE: Verify the hash token value
        let payload = {
            new_reseller_id: localStorage.getItem('loggedInPartnerId'),
            status: localStorage.getItem('clientRebateStatus')
        }
        
        this.$axiosSecureClient.post('/file-data', payload).then(res => {
            // NOTE: Set upload list details
            if(res && res.data) {
                this.clientId = res.data.data.new_reseller_id;
                this.pocName = this.toTitleCase(res.data.data.poc_name);
                this.pocEmail = res.data.data.poc_email;
                this.listFrequency = res.data.data.list_frequency;
                this.period = res.data.data.rebates_month + ' ' +  res.data.data.rebates_year;
                this.pendingMonths = res.data.data.pending_months;
                this.dueDateForUpload = this.$moment(res.data.data.date_to_submit_list, 'YYYY-MM-DD').format('Do MMMM, YYYY');
                this.dataDateRangeStart = res.data.data.date_range_start;
                this.dataDateRangeEnd = res.data.data.date_range_end;

                this.setSampleFile(res.data.data.file_format);
            }
        }).catch(error => {
            // NOTE: Token is invalid (500)
            console.error(error);
        })
    },
    methods: {
        initData() {
            return {
                clientId: '',
                pocName: '',
                pocEmail: '',
                listFrequency: '',
                period: '',
                pendingMonths: [],
                dueDateForUpload: '',
                dataDateRangeStart: '',
                dataDateRangeEnd: '',
                sampleFile: {
                    url: null,
                    label: null
                },
            }
        },
        setSampleFile(fileFormat) {
            switch(fileFormat) {
                case 'simple-bundled':
                    this.sampleFile.url = 'assets/simple-bundled/sample-rebates-file.xlsx';
                    this.sampleFile.label = 'sample-rebates-file';
                    break;
                case 'multireseller':
                    this.sampleFile.url = 'assets/multi-reseller/sample-rebates-file.xlsx';
                    this.sampleFile.label = 'sample-rebates-file-multi-reseller';
                    break;
                default:
                    this.sampleFile.url = 'assets/simple-bundled/sample-rebates-file.xlsx';
                    this.sampleFile.label = 'sample-rebates-file';
            }
        },
        uploadRebateLists() {
            let args = { 
                clientId: this.clientId,
                pocName: this.pocName,
                pocEmail: this.pocEmail,
                listFrequency: this.listFrequency,
                period: this.period,
                pendingMonths: this.pendingMonths,
                dueDateForUpload: this.dueDateForUpload,
                dataDateRangeStart: this.dataDateRangeStart,
                dataDateRangeEnd: this.dataDateRangeEnd
            };
            
            this.$root.$emit("openUploadRebateListsPopup", args);
        },
        downloadSampleFile ({ url, label }) {
            this.$axiosSecure.get(`${process.env.VUE_APP_BASE_URL}${url}`, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = label
                link.click()
                URL.revokeObjectURL(link.href)
            })
            .catch((error) => {
                console.error(error);
            })
        },
    },
    destroyed() {
        this.$root.$off('submitRebateList');
    }
};
</script>